let fetchSeq = 0;

async function resetAndFetch(commit, dispatch) {
    commit('SET_PAGINATION', { page: 1 });
    await dispatch('fetchDocuments');
}

let actions = {
    fetchDocuments: async function ({ commit, state }, params) {
        const seq = ++fetchSeq;
        commit('SET_FETCHING', true);
        try {
            const fetchParams = { ...(params || state.lastParams) };

            if (params) {
                commit('SET_LAST_PARAMS', { ...params });
                commit('CLEAR_ACTIVE_FILTERS');
            }

            fetchParams.page = state.page;
            fetchParams.per_page = state.per_page;

            if (state.activeSort.column) {
                fetchParams.sort_column = state.activeSort.column;
                fetchParams.sort_direction = state.activeSort.direction || 'DESC';
            }

            const hasInFilters   = Object.keys(state.activeFilters).length > 0;
            const hasLikeFilters = Object.keys(state.activeLikeFilters).length > 0;
            if (hasInFilters || hasLikeFilters) {
                const columnFilters = {};
                Object.entries(state.activeFilters).forEach(([col, values]) => {
                    columnFilters[col] = { type: 'in', values };
                });
                Object.entries(state.activeLikeFilters).forEach(([col, value]) => {
                    columnFilters[col] = { type: 'like', value };
                });
                fetchParams.columnFilters = columnFilters;
            }

            const response = await axios.post('/documents/list', fetchParams);

            if (seq !== fetchSeq) return;

            const data = response.data;
            const docs = data.documents || [];

            const totalCount = (data.total_count !== null && data.total_count !== undefined)
                ? data.total_count
                : (state.page - 1) * state.per_page + docs.length;

            commit('UPDATE_ROWS', docs);
            commit('SET_TOTAL_COUNT', totalCount);
            return data;
        } finally {
            if (seq === fetchSeq) commit('SET_FETCHING', false);
        }
    },

    sortRows: async function ({ commit, dispatch }, sort_info) {
        const direction = sort_info.descending ? 'DESC' : 'ASC';
        commit('SET_SORT', { column: sort_info.column, direction });
        commit('SET_PAGINATION', { page: 1 });
        return dispatch('fetchDocuments');
    },

    updateRows: function ({ commit }, data) {
        if (!('rows' in data) && Array.isArray(data)) {
            data.rows = data;
        }
        if (!('filter_data' in data)) {
            data.filter_data = data.rows;
        }
        commit('UPDATE_ROWS', data.rows);
    },

    toggleInProgress: function ({ commit }) {
        commit('TOGGLE_IN_PROGRESS');
    },

    selectRow: function ({ commit, getters }, row_index) {
        commit('SELECT_ROW', getters.visibleRows[row_index]);
    },

    deselectRow: function ({ commit, getters }, row_index) {
        commit('DESELECT_ROW', getters.visibleRows[row_index]);
    },

    removeFilter: async function ({ commit, dispatch }, info) {
        commit('REMOVE_FILTER', info);
        await resetAndFetch(commit, dispatch);
    },

    removeColumnFilters: async function ({ commit, dispatch }, column) {
        if (!column) return;
        commit('CLEAR_COLUMN_FILTERS', column);
        await resetAndFetch(commit, dispatch);
    },

    clearAllColumnFilters: async function ({ commit, dispatch }) {
        commit('CLEAR_ACTIVE_FILTERS');
        await resetAndFetch(commit, dispatch);
    },

    addFilter: async function ({ commit, dispatch }, info) {
        commit('REMOVE_LIKE_FILTER', info.column);
        commit('ADD_FILTER', info);
        await resetAndFetch(commit, dispatch);
    },

    addLikeFilter: async function ({ commit, dispatch }, { column, value }) {
        commit('CLEAR_COLUMN_FILTERS', column);
        commit('ADD_LIKE_FILTER', { column, value });
        await resetAndFetch(commit, dispatch);
    },

    applyColumnFilters: async function ({ commit, dispatch }, { column, toAdd, toRemove }) {
        commit('REMOVE_LIKE_FILTER', column);
        toAdd.forEach(filter => commit('ADD_FILTER', { column, filter }));
        toRemove.forEach(filter => commit('REMOVE_FILTER', { column, filter }));
        await resetAndFetch(commit, dispatch);
    },

    removeLikeFilter: async function ({ commit, dispatch }, column) {
        commit('REMOVE_LIKE_FILTER', column);
        await resetAndFetch(commit, dispatch);
    },

    changeStartDate: function ({ commit }, date) {
        commit('CHANGE_START_DATE', date);
    },

    changeEndDate: function ({ commit }, date) {
        commit('CHANGE_END_DATE', date);
    },

    searchUpdated: function ({ commit }, updated = true) {
        commit('NEED_TO_SEARCH', updated);
    },

    checkSelectAllButton: function ({ commit }, checked = true) {
        commit('SELECT_ALL_CHECKED', checked);
    },

    toggleBalanceColumn: function ({ commit }, visible = true) {
        commit('SHOW_BALANCE_COLUMN', visible);
    },

    updateClientSampleTypes: function ({ commit }, items = []) {
        commit('UPDATE_CLIENT_SAMPLE_TYPES', items);
    },

    updateSelectedSampleTypes: function ({ commit }, selection = []) {
        commit('UPDATE_SELECTED_SAMPLE_TYPES', selection);
    },

    updateDocTypes: function ({ commit }, types = []) {
        commit('UPDATE_DOCUMENT_TYPES', types);
    },

    updateSelectedDocTypeCodes: function ({ commit }, codes = []) {
        commit('UPDATE_SELECTED_DOC_TYPE_CODES', codes);
    },

    updateUserAccountRoles: function ({ commit }, userAccountRoles = []) {
        commit('UPDATE_USER_ACCOUNT_ROLES', userAccountRoles);
    },

    updateUserIsSysAdmin: function ({ commit, state }, is_sys_admin = false) {
        commit('UPDATE_USER_IS_SYS_ADMIN', is_sys_admin);
    },

    setItemValue: function ({ commit }, params = {}) {
        commit('SET_ITEM_VALUE', params)
    },

    getReportFormats({ commit }, account_nbr) {
        commit('GET_REPORT_FORMATS', account_nbr)
    },

    emailReports({ commit }, params) {
        commit('EMAIL_REPORTS', params)
    },

    setOutliersOnly({ commit }, value) {
        commit('SET_OUTLIERS_ONLY', value);
    },

    setProjectPO: function ({ commit }, value) {
        commit('SET_PROJECT_PO', value);
    },

    fetchFilterValues: async function ({ commit, state }, options) {
        const { params = null, accountNbr = null } = options || {};
        const requestParams = params || state.lastParams;
        if (!requestParams || !requestParams.docTypes) return;

        commit('SET_FILTER_VALUES_LOADING', true);
        try {
            const fetchParams = { ...requestParams };

            if (accountNbr !== null) {
                fetchParams.accountNbrs = [accountNbr];
            }

            const response = await axios.post('/documents/filter-values', fetchParams);
            const data = response.data;

            if (data && data.filterValues) {
                Object.entries(data.filterValues).forEach(([acctNbr, values]) => {
                    commit('SET_FILTER_VALUES_FOR_ACCOUNT', {
                        accountNbr: parseInt(acctNbr),
                        values
                    });
                });
            }
        } catch (e) {
            console.error('fetchFilterValues failed', e);
        } finally {
            commit('SET_FILTER_VALUES_LOADING', false);
        }
    },

    removeAccountFilterValues: function ({ commit }, accountNbr) {
        commit('REMOVE_FILTER_VALUES_FOR_ACCOUNT', accountNbr);
    },

    clearAllFilterValues: function ({ commit }) {
        commit('CLEAR_ALL_FILTER_VALUES');
    },

};

export default actions;


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/documents/actions.js